import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TravellerTermsAndConditions.module.css';
import { useNavigate } from 'react-router-dom';
import { Container } from '@bookingcom/bui-react';
import { Helmet } from 'react-helmet';
import { useTravellerTermsHtml } from './useTravellerTermsHtml';

const TravellerTermsAndConditions = () => {
  const { t } = useTranslation();
  const termsHtml = useTravellerTermsHtml();
  const navigate = useNavigate();
  const backButtonText = t('back_button');
  const headerRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headerRef.current?.focus();
  }, []);

  return (
    <div data-testid="termsAndConditionsTestId">
      <Container centered className={styles.termsAndConditionsContainer}>
        <Helmet>
          <title>{'Terms & Conditions | Booking.com'}</title>
        </Helmet>
        <Container centered className={styles.termsContainer}>
          <button
            className={styles.backButton}
            onClick={() => navigate('/')}
            aria-label={backButtonText}>
            <span className={styles.backButtonText}>{t('back_button')}</span>
          </button>
          <h2 ref={headerRef} tabIndex={-1} className={styles.termsAndConditionsHeading}>
            {t('terms_conditions_link')}
          </h2>
          {termsHtml ? (
            <div
              className={styles.termsAndConditionsHtml}
              data-testid="travellerTermsAndConditionsHtmlContent"
              dangerouslySetInnerHTML={{ __html: termsHtml }}
            />
          ) : null}
        </Container>
      </Container>
    </div>
  );
};

export default TravellerTermsAndConditions;
